<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>直连文件查询</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">直连文件查询</h1>
    <div class="view-content">
      <el-card class="box-card">
        <div class="view-filter">
          <el-form :inline="true" :model="filterForm">
            <el-form-item label="时间筛选">
              <el-date-picker
                value-format="yyyy-MM-dd"
                size="small"
                v-model="filterForm.date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="任务类型">
              <el-select
                size="small"
                v-model="filterForm.task_type"
                placeholder="任务类型"
              >
                <el-option
                  :label="item.label"
                  :value="item.value"
                  v-for="item in reportTypeMap"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="任务属性">
              <el-select
                size="small"
                v-model="filterForm.task_attr"
                placeholder="任务类型"
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="常规任务" value="1"></el-option>
                <el-option label="临时任务" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="filterForm.find_value"
                class="search-text"
                size="small"
                placeholder="请输入编码或名称"
              >
                <el-button slot="append" @click="onSearch">查找</el-button>
              </el-input>
            </el-form-item>

            <el-form-item label="数据内容">
              <el-select
                @change="statusChange"
                size="small"
                multiple
                v-model="filterForm.flow_data_filter"
                placeholder="数据内容"
              >
                <el-option
                  :label="item.value"
                  :value="item.key + ''"
                  v-for="item in statusList"
                  :key="item.key + ''"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="card-content">
          <div class="table-tool">共{{ totalCount }}条</div>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="plugin_code" label="插件编码">
            </el-table-column>
            <el-table-column prop="client_code" label="经销商编码">
            </el-table-column>
            <el-table-column prop="client_name" label="经销商名称">
              <template slot-scope="scope">
                <div class="dealer-name-wrapper">
                  <span class="dealer-name">{{ scope.row.client_name }}</span>
                  <el-tag 
                    v-if="scope.row.is_new === 1" 
                    class="new-tag"
                    size="small"
                  >新</el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="start_time" label="开始传输时间">
            </el-table-column>
            <el-table-column prop="end_time" label="结束传输时间">
            </el-table-column>
            <el-table-column prop="task_type" label="任务类型">
              <template slot-scope="scope">
                {{
                  {
                    1: "销售日报",
                    2: "采购日报",
                    3: "库存日报",
                    4: "销售周报",
                    5: "采购周报",
                    6: "库存周报",
                    7: "销售月报",
                    8: "采购月报",
                    9: "库存月报",
                  }[scope.row.task_type]
                }}
              </template>
            </el-table-column>

            <el-table-column prop="status_desc" label="数据内容">
            </el-table-column>

            <el-table-column prop="task_attr" label="任务属性">
              <template slot-scope="scope">
                <span v-if="scope.row.task_attr === 1">常规任务</span>
                <span v-if="scope.row.task_attr === 2">临时任务</span>
              </template>
            </el-table-column>
            <el-table-column prop="file_path" label="任务文件" width="360">
              <template slot-scope="scope">
                <p v-if="!scope.row.file_name || scope.row.file_name === ''">
                  无数据
                </p>
                <p v-if="scope.row.file_name && scope.row.file_name !== ''">
                  <a
                    v-if="scope.row.file_path && scope.row.file_path !== ''"
                    :href="scope.row.file_path"
                    >{{ scope.row.file_name }}</a
                  >

                  <a
                    v-if="!scope.row.file_path || scope.row.file_path === ''"
                    href="javascript:;"
                    @click="onExport(scope.row)"
                    >{{ scope.row.file_name }}</a
                  >

                  <!-- <span
                    v-if="!scope.row.file_path || scope.row.file_path === ''"
                    >{{ scope.row.file_name }}</span
                  > -->
                </p>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="block" v-if="totalPage > 1">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="20"
            layout="prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { uploadfileLogList, enumBusinessList } from "@/api/index";
import moment from "moment";
import { downloadLogFile } from "@/api/export";

export default {
  name: "upFileInquire",
  data: () => ({
    currentPage: 1,
    totalCount: 0,
    searchText: "",
    tableData: [],
    totalPage: 1,
    reportTypeMap: [
      { label: "全部", value: "" },
      { label: "销售日报", value: "1" },
      { label: "采购日报", value: "2" },
      { label: "库存日报", value: "3" },
      { label: "销售周报", value: "4" },
      { label: "采购周报", value: "5" },
      { label: "库存周报", value: "6" },
      { label: "销售月报", value: "7" },
      { label: "采购月报", value: "8" },
      { label: "库存月报", value: "9" },
    ],
    filterForm: {
      task_type: "",
      task_attr: "",
      date: "",
      find_value: "",
      flow_data_filter: ["1"],
    },
    statusList: [],
  }),
  created() {
    let upFile = window.sessionStorage.getItem("upFile");
    this.type = this.$route.params.type;
    if (upFile && this.type === "2") {
      upFile = JSON.parse(upFile);
      this.upFile = upFile;
      this.filterForm.task_type = upFile.report_type + "";
    }
    setTimeout(() => {
      window.sessionStorage.removeItem("upFile");
    }, 100);

    this.filterForm.date = [
      moment().startOf('month').format('YYYY-MM-DD'),
      moment().endOf('month').format('YYYY-MM-DD')
    ]

    this.getenumBusinessList();
  },
  mounted() {
    this._getList(1);
  },
  methods: {
    onExport(row) {
      let parameter = {
        upload_file_log_id: row.upload_file_log_id,
      };
      downloadLogFile(parameter);
    },
    getenumBusinessList() {
      let par = {
        enum_name_arr: ["FlowDataFilterEnum"],
      };
      enumBusinessList(par).then((res) => {
        if (res.status == 0) {
          let data = res.data;
          for (const iterator of data) {
            for (const key in iterator) {
              if (Object.hasOwnProperty.call(iterator, key)) {
                const element = iterator[key];
                if (key == "FlowDataFilterEnum") {
                  this.statusList = element;
                }
              }
            }
          }
        }
      });
    },

    statusChange(value) {
      console.log(value, "valuuuuuu");
      if (value[value.length - 1] === "0") {
        // setTimeout(() => {
        this.filterForm.flow_data_filter = ["0"];
        // }, 400)
      } else if (value.indexOf("0") > -1) {
        // setTimeout(() => {
        const list = value.filter((item) => item !== "0");
        this.filterForm.flow_data_filter = list;
        // }, 400)
      } else {
      }
    },
    _getList(page) {
      let filterForm = { ...this.filterForm };
      if (filterForm.date && filterForm.date !== "") {
        filterForm.start_time = filterForm.date[0];
        filterForm.end_time = filterForm.date[1];
      } else {
        filterForm.start_time = "";
        filterForm.end_time = "";
      }
      if (this.upFile && this.type === "2") {
        filterForm.task_type = this.upFile.report_type + "";
        filterForm.temporary_grab_id = this.upFile.temporary_grab_id;
        this.upFile = null;
      }
      filterForm.page = page;
      filterForm.flow_data_filter = filterForm.flow_data_filter.join(",");
      uploadfileLogList(filterForm).then((res) => {
        if (0 === res.status) {
          this.tableData = res.data.clientPage;
          this.totalCount = res.data.totalCount;
          this.currentPage = parseInt(res.data.currentPage);
          this.totalPage = res.data.totalPage;
        } else {
          this.tableData = [];
          this.currentPage = 1;
          this.totalCount = 0;
          this.totalPage = 0;
        }
      });
    },
    onSearch() {
      this.type = "2";
      this._getList(1);
    },
    handleCurrentChange(val) {
      this._getList(val);
    },
  },
};
</script>

<style scoped>
.dealer-name-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
}

.dealer-name {
  flex: 1;
  word-wrap: break-word;
  word-break: break-all;
}

.new-tag {
  flex-shrink: 0;
  color: white;
  background-color: #409EFF;
}
</style>
